// extracted by mini-css-extract-plugin
export var statItem = "_mf-1";
export var statsRow = "_mf-0";